// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NoKT","left":"styles_left__1uBh-"};